module.exports = __webpack_public_path__ + "img/13.253e50bd.png";